<div class="grid h-full overflow-y-auto" role="dialog" [attr.aria-label]="title">
  <header class="fixed top-0 w-full z-10" *ngIf="!hideHeader">
    <div
      class="grid grid-cols-[auto_1fr_auto] gap-1 items-center text-center justify-items-center p-5 bg-white"
      [ngClass]="[!progress ? 'border-b border-gray-200' : '']">
      <ui-button (onClick)="backClicked.emit()" icon="griddy-chevron-left" variant="tertiary"></ui-button>
      <span>{{ title }}</span>
      <ui-close [border]="true" size="md" (click)="closeClicked.emit()" />
    </div>
    <div class="w-full border-b border-gray-200 bg-white" *ngIf="progress > 0">
      <div class="w-full h-1">
        <div
          class="h-full bg-primary-600 transition-all duration-300 ease-out"
          [style.width.%]="progress"
          role="progressbar"
          [attr.aria-valuenow]="progress"
          [attr.aria-valuemin]="0"
          [attr.aria-valuemax]="100"></div>
      </div>
    </div>
    <div class="bottom-gradient"></div>
  </header>

  <section
    data-testid="content"
    class="w-full px-5 justify-self-center pb-32"
    [ngClass]="[contentClass, sizeClass, contentTopMargin]">
    <ng-content></ng-content>
  </section>

  <footer class="fixed bottom-0 w-full z-10" *ngIf="!hideFooter">
    <div class="top-gradient"></div>
    <div class="grid border-t border-gray-200 bg-white">
      <div class="w-full p-5 justify-self-center" [ngClass]="sizeClass">
        <!-- If you need an escape hatch - (https://www.figma.com/design/SMH71Gb327wWfxwiYPjuwS/Cleanster?node-id=6070-16009&m=dev) -->
        <ng-content select="[footerActions]"></ng-content>

        <div *ngIf="primaryAction || secondaryAction" class="grid grid-flow-col gap-1" [ngClass]="actionsIndent">
          <ui-button
            *ngIf="secondaryAction"
            [label]="secondaryAction.label"
            [loading]="secondaryAction.loading ?? false"
            [disabled]="secondaryAction.disabled ?? false"
            (onClick)="secondaryAction.onClick()"
            size="lg"
            variant="tertiary"></ui-button>
          <ui-button
            *ngIf="primaryAction"
            [label]="primaryAction.label"
            [loading]="primaryAction.loading ?? false"
            [disabled]="primaryAction.disabled ?? false"
            size="lg"
            (onClick)="primaryAction.onClick()"></ui-button>
        </div>
      </div>
    </div>
  </footer>
</div>
